interface CopyObservation<T, Detail> {
  copied(target: T, detail: Detail | undefined, verifyPayload: boolean): void
  failed(): void
}

export function createCopyObservations<T extends object, Detail>() {
  let observations: WeakMap<T, CopyObservation<T, Detail>> | undefined
  return {
    observe(source: T, observation: CopyObservation<T, Detail>) {
      observations ??= new WeakMap()
      observations.set(source, observation)
    },
    copy<Copy extends T>(source: T, target: Copy, detail?: Detail, verifyPayload = true): Copy {
      const observation = observations?.get(source)
      if (observation) {
        try {
          observation.copied(target, detail, verifyPayload)
        } catch {
          try {
            observation.failed()
          } catch {
            // eslint-disable-next-line no-console
            console.error('Unable to report command copy observation error')
          }
        }
      }
      return target
    },
  }
}
